import classNames from "classnames";

import {
  TENANT_ICON_HEIGHT_CLASS,
  TENANT_ICON_WIDTH_CLASS,
} from "features/layout/TenantIcon/constants";

interface Props {
  image: string;
}

const TenantIconImage = ({ image }: Props) => (
  <img
    src={image}
    alt=""
    className={classNames(
      "rounded-sm object-cover border border-slate-300",
      TENANT_ICON_WIDTH_CLASS,
      TENANT_ICON_HEIGHT_CLASS
    )}
  />
);

export default TenantIconImage;
